import store from "../../store";
import { userState } from "@/store/modules/user";
import configs from "@/configs/pathConfigures";
import String from "@/utils/String";
import Account from "@/api/login";
import { MessageBox } from "element-ui";
//本次不做api权限，因为后台jeecg框架无法直接使用需要改造。
// function hasPermisson(roles,permissionRoles){
//     if(roles.indexOf('admin') >= 0) return true
//     if((!permissionRoles)) return true
//     return roles.some(role=>permissionRoles.indexOf(role) >= 0)
// }

const loginPath = configs.prefixUrl + "/account/login";
const homePath = configs.prefixUrl + "/home";
const registerPath = configs.prefixUrl + "/account/register";
const settingPath = configs.prefixUrl + "/account/Setting";
const userAgreementPath = configs.prefixUrl + "/userAgreement";
const privacyPolicyPath = configs.prefixUrl + "/privacyPolicy";
const licensePath = `${configs.prefixUrl}/license`;
const teacherInvitePath = `${configs.prefixUrl}/invite/catUser`;
const studentInvitePath = `${configs.prefixUrl}/invite/student`;
const acountForgotPath = `${configs.prefixUrl}/account/forgot`;
const whiteList = [
  loginPath,
  registerPath,
  settingPath,
  userAgreementPath,
  privacyPolicyPath,
  licensePath,
  teacherInvitePath,
  studentInvitePath,
  acountForgotPath,
];
import { isBlank } from "@/utils/String";
import { getToken } from "../../utils/auth";
import { Persistent } from "../../utils/cache/persistent";
function validateRoute(to) {
  if (!to) return true;

  //find first route who has meta.role
  let validateNeededRoute = (to.matched || []).$$first((r) => r.path == to.path);
  while (validateNeededRoute) {
    if (!validateNeededRoute.meta || !validateNeededRoute.meta.role) {
      validateNeededRoute = validateNeededRoute.parent;
    } else {
      break;
    }
  }
  if (validateNeededRoute) {
    const accessRoles = validateNeededRoute.meta.role
      .split(",")
      .filter((r) => !isBlank(r))
      .map((r) => r.trim());
    let roleOfUser = [];
    if (Store.state.user.roles) {
      if (Store.state.user.roles instanceof Array) {
        roleOfUser = Store.state.user.roles;
      } else if (typeof Store.state.user.roles == "string") {
        roleOfUser = Store.state.user.roles
          .split(",")
          .filter((r) => !isBlank(r))
          .map((r) => r.trim());
      }
    }
    for (const ar of accessRoles) {
      for (const ur of roleOfUser) {
        if (ar == ur) return true;
      }
    }
    return false;
  } else {
    return true;
  }
}

function _hasRoutePermissonRecursion(toPath, parentPath, routes) {
  if (!toPath) {
    return false;
  }

  if (!routes) {
    routes = [];
  }

  for (var i = 0; i < routes.length; i++) {
    var current = routes[i];
    if (!current) {
      continue;
    }

    //这里为了解决因为系统中所有的路由均以configs.prefixUrl为前缀。
    //导致所有页面均有访问权限的问题
    if (toPath.indexOf(homePath) == -1 && current.path == configs.prefixUrl) {
      continue;
    }

    var currentPath = current.path;
    var currentFullPath = String.combine(parentPath, currentPath);
    var pos = toPath.indexOf(currentFullPath);
    if (pos === 0) {
      // return true;
      if (toPath == currentFullPath) {
        return true;
      }
      var hasPermission = _hasRoutePermissonRecursion(toPath, currentFullPath, current.children);
      if (hasPermission) {
        return true;
      }
    } else {
      continue;
    }
  }
}
function _buildMenus(parent, localMenus, serverMenus) {
  var resultMenus = [];
  if (!localMenus) {
    localMenus = [];
  }
  for (var i = 0; i < localMenus.length; i++) {
    var current = localMenus[i];

    if (!_exists(parent, current, serverMenus)) {
      continue;
    }
    resultMenus.push(current);
  }

  for (var i = 0; i < resultMenus.length; i++) {
    var current = resultMenus[i];
    current.children = _buildMenus(current, current.children, serverMenus);
  }

  return resultMenus;
}
function _exists(parentMenu, menu, serverMenus) {
  //判断服务器菜单权限
  var parentMenuPath = parentMenu ? parentMenu.path : "";
  var path = String.combine(parentMenuPath, menu.path);
  var exists = false;
  for (var i = 0; i < serverMenus.length; i++) {
    var current = serverMenus[i];
    var serverPath = String.combine(current.parentPath, current.path);
    if (serverPath.toLowerCase() == path.toLowerCase()) {
      exists = true;
      break;
    }
    exists = _exists(parentMenu, menu, current.children);
    if (exists) {
      break;
    }
  }

  return exists;
}

let isFirstLoading = true;

export function usePermissionGuard(router) {
  router.beforeEach(async (to, from, next) => {
    if ((to.meta && to.meta.test) || whiteList.indexOf(to.path) > -1 || to.meta.test) {
      next();
      return;
    }

    if (!!to /*&& !validateRoute(to)*/) {
      const token = getToken();
      if (!token) {
        next({ name: "login", query: { redirect: to.fullPath } });
        return;
      } else {
        try {
          if (!store.getters.isPageUserLoadded) {
            await store.dispatch("afterLoginAction");
          }
          if (!store.getters.isMenuLoaded) {
            await store.dispatch("loadMenu");
          }
          next();
        } catch (ex) {
          MessageBox.alert(ex.message, "系统提示");
          Persistent.clearAll(true);
          next({ name: "login" });
        }
        return;
      }
    }

    next();
    return;
  });
  router.afterEach((to, from) => {
    console.log("#-# to", { ...to });
    //notifyPageRended();
  });
}
